import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import ACVerticalStepper from '../../progress/ACVerticalStepper';
import LessonNavigatorAsset from './LessonNavigatorAsset';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ColorOnHover = styled.span.withConfig({
  displayName: "ACLessonNavigator__ColorOnHover"
})(["&:hover h4{color:", ";}"], ({
  theme
}) => theme.color['text-interactive-default-hover']);
const ACLessonNavigator = ({
  title,
  helpText,
  assets,
  activeAssetId,
  active,
  optionalNavStartSteps,
  optionalSteps,
  menuIcon,
  lessonId,
  courseId
}) => {
  const {
    isLaptop,
    isMobile
  } = useMediaQuery();
  const [expanded, setExpanded] = useState(active);
  const shouldTruncate = isLaptop && !isMobile;
  useEffect(() => {
    setExpanded(active);
  }, [active]);
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: active ? 'fill-field-pressed' : 'fill-surface-default',
    "data-test-id": "lesson-navigator-container",
    minInlineSize: "0",
    overflow: "hidden",
    paddingBlock: "400",
    children: /*#__PURE__*/_jsxs(AccordionItem, {
      "data-test-id": "lesson-navigator-item",
      onOpenChange: () => setExpanded(!expanded),
      open: expanded,
      paddingInline: "400",
      removeContentPadding: true,
      size: "md",
      title: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "stretch",
        flexDirection: "row",
        marginBlockEnd: "-300",
        marginInlineStart: "200",
        children: [/*#__PURE__*/_jsx(Flex, {
          flexGrow: 1,
          minInlineSize: "0",
          children: /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "column",
            children: [/*#__PURE__*/_jsx(ColorOnHover, {
              children: shouldTruncate ? /*#__PURE__*/_jsx(TruncateString, {
                children: /*#__PURE__*/_jsx(Text, {
                  as: "h4",
                  marginBlockEnd: "100",
                  children: title
                })
              }) : /*#__PURE__*/_jsx(Text, {
                as: "h4",
                marginBlockEnd: "100",
                children: title
              })
            }), helpText && (shouldTruncate ? /*#__PURE__*/_jsx(TruncateString, {
              children: /*#__PURE__*/_jsx(Text, {
                as: "small",
                children: helpText
              })
            }) : /*#__PURE__*/_jsx(Text, {
              as: "small",
              children: helpText
            }))]
          })
        }), menuIcon && /*#__PURE__*/_jsx(Flex, {
          "data-test-id": "menu-icon",
          flexBasis: "30px",
          flexShrink: 0,
          children: menuIcon
        })]
      }),
      children: [optionalNavStartSteps && /*#__PURE__*/_jsx(View, {
        "data-test-id": "optional-nav-start-steps",
        marginInline: "-400",
        children: optionalNavStartSteps
      }), /*#__PURE__*/_jsx(List, {
        paddingInlineStart: "700",
        children: /*#__PURE__*/_jsx(ACVerticalStepper, {
          activeStep: assets.findIndex(asset => asset.id === activeAssetId),
          iconOffset: "400",
          renderStep: step => /*#__PURE__*/_jsx(ListItem, {
            marginBlock: "100",
            children: /*#__PURE__*/_jsx(LessonNavigatorAsset, {
              active: step.id === activeAssetId,
              courseId: courseId,
              helpText: step.helpText,
              id: step.id,
              lessonId: lessonId,
              showFocus: step.showFocus,
              title: step.title
            }, step.id)
          }),
          steps: assets
        })
      }), optionalSteps && /*#__PURE__*/_jsx(View, {
        "data-test-id": "optional-steps",
        children: optionalSteps
      })]
    })
  });
};
export default ACLessonNavigator;